import { Tag } from "antd";

import { humanizeStatus, type ResourceKind, type StatusTone } from "@/lib/terms";

const TONE_COLOR: Record<StatusTone, string> = {
  success: "green",
  processing: "blue",
  error: "red",
  warning: "gold",
  neutral: "default",
};

export interface StatusTagProps {
  status?: string | null;
  /** Resource family, used to pick the right status vocabulary. */
  kind?: ResourceKind;
}

/**
 * Renders a resource status as a friendly, customer-facing tag
 * (e.g. ACTIVE -> "Running"). The single source of status presentation —
 * replaces the ad-hoc per-feature STATUS_COLORS maps. See @/lib/terms.
 */
function StatusTag({ status, kind }: StatusTagProps) {
  const { label, tone } = humanizeStatus(status, kind);
  return <Tag color={TONE_COLOR[tone]}>{label}</Tag>;
}

export default StatusTag;
